// AddDatabaseModalOption.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './AddDatabaseModalOption.css';

// Icons
import Icon from 'svg/Icon';

/**
 * AddDatabaseModalOption
 * 
 * Reusable option component for the AddDatabaseModal landing page, representing a single action with an 
 * icon, title, and subtitle.
 * 
 * @param {string} iconKey - Key for the Icon to display.
 * @param {string} title - Main title text for the option.
 * @param {string} subtitle - Supporting text describing the option.
 * @param {function} onClick - Called when the option is selected.
 *  
 *
 * @returns {ReactNode} - AddDatabaseModalOption.
 */
const AddDatabaseModalOption = React.memo(({ iconKey, title, subtitle, onClick }) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state

    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div
          className="add-database-modal-option-container"
          style={{
            backgroundColor: hovered ? theme.buttonHoverBackgroundColor : theme.buttonBackgroundColor,
            color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
          }}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >

            {/* OPTION ICON */}
            <div className="add-database-modal-option-icon">
                <Icon
                  iconKey={iconKey}
                  width={26}
                  height={26}
                  color={hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted}
                />
            </div>

            {/* OPTION CONTENT */}
            <div className="add-database-modal-option-content">

                {/* OPTION TITLE */}
                <div className="add-database-modal-option-title">
                    {title}
                </div>

                {/* OPTION SUBTITLE */}
                <div
                  className="add-database-modal-option-subtitle"
                  style={{
                        color: hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted
                    }}
                >
                    {subtitle}
                </div>

            </div>

            <Icon
              iconKey="chevron_right"
              width={18}
              height={18}
              color={hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted}
            />

        </div>
    );

});

// Dev Tools
AddDatabaseModalOption.displayName = 'AddDatabaseModalOption';

export default AddDatabaseModalOption;
